(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-navigation-item-with-dropdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const dropdownItems = document.querySelectorAll('.header__nav-item.with-dropdown');
  const isTouchDevice = window.matchMedia('(hover: none)').matches;

  dropdownItems.forEach(item => {
    const trigger = item.querySelector('.header__nav-link');

    if (isTouchDevice) {
      // Klik na mobilu/tabletu
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = item.classList.contains('with-dropdown--open');

        // Pokud je už otevřený, zavřeme ho
        if (isOpen) {
          item.classList.remove('with-dropdown--open');
          return;
        }

        // Zavřít všechny ostatní dropdowny
        dropdownItems.forEach(i => i.classList.remove('with-dropdown--open'));

        // Otevřít aktuální
        item.classList.add('with-dropdown--open');
      });

      // Klik mimo zavře
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) {
          item.classList.remove('with-dropdown--open');
        }
      });

    } else {
      // Hover na desktopu s delayem
      let openTimeout, closeTimeout;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(() => {
          dropdownItems.forEach(i => i.classList.remove('with-dropdown--open'));
          item.classList.add('with-dropdown--open');
        }, 125);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(() => {
          item.classList.remove('with-dropdown--open');
        }, 125);
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordions"] && !Shopify.designMode) return;
  try {
    const accordions = document.querySelectorAll('.accordion');
accordions.forEach(accordion => {
    const header = accordion.querySelector('.accordion__header');
    const icon = header.querySelector('i');
    header.addEventListener('click', () => {
        accordion.classList.toggle('accordion--open');
        if (icon.classList.contains('fa-plus')) {
            icon.classList.replace('fa-plus', 'fa-minus');
        } else {
            icon.classList.replace('fa-minus', 'fa-plus');
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq-toggle]').forEach(toggle => {
        toggle.addEventListener('click', () => {
        const item = toggle.closest('[data-faq-item]');
        const answer = item.querySelector('[data-faq-answer]');
        const isOpen = item.classList.contains('open');
        item.classList.toggle('open');
        });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider__wrapper').forEach(slider => {
    const content = slider.querySelector('.slider__content');
    const btnLeft = slider.querySelector('.slider__arrow--left');
    const btnRight = slider.querySelector('.slider__arrow--right');

    if (!content || !btnLeft || !btnRight) return;

    function updateArrows() {
      const maxScrollLeft = content.scrollWidth - content.clientWidth - 1;
      const atStart = content.scrollLeft <= 1;
      const atEnd = content.scrollLeft >= maxScrollLeft;

      slider.querySelector('.slider').classList.toggle('slider--scrolled-to-end', atEnd);
      slider.querySelector('.slider').classList.toggle('slider--scrolled-to-start', atStart);

      if(atStart) {
        btnRight.classList.remove('slider__arrow--disabled');
        btnLeft.classList.add('slider__arrow--disabled');
      }
      else if(atEnd) {
        btnRight.classList.add('slider__arrow--disabled');
        btnLeft.classList.remove('slider__arrow--disabled');
      }
      else {
        btnRight.classList.remove('slider__arrow--disabled');
        btnLeft.classList.remove('slider__arrow--disabled');
      }
    }

    btnLeft.addEventListener('click', () => {
      const itemWidth = content.querySelector(':scope > *')?.offsetWidth || content.clientWidth;
      content.scrollBy({ left: -itemWidth - parseInt(getComputedStyle(content).gap), behavior: 'smooth' });
    });

    btnRight.addEventListener('click', () => {
      const itemWidth = content.querySelector(':scope > *')?.offsetWidth || content.clientWidth;
      content.scrollBy({ left: itemWidth + parseInt(getComputedStyle(content).gap), behavior: 'smooth' });
    });

    content.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".tabs-wrapper").forEach(wrapper => {
      const buttons = wrapper.querySelectorAll(".tab-button");
      const panels = wrapper.querySelectorAll(".tab-panel");

      panels[0]?.classList.add("active");
      buttons[0]?.classList.add("active");

      buttons.forEach(button => {
        button.addEventListener("click", () => {
          const targetId = "tab-" + button.dataset.tab;

          buttons.forEach(btn => btn.classList.remove("active"));
          panels.forEach(panel => panel.classList.remove("active"));

          button.classList.add("active");
          wrapper.querySelector("#" + targetId)?.classList.add("active");
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
